define('modules/form_editor/views/preview_text',['require','exports','module','./preview_base','ldsh!../templates/input_text'],function(require, exports, module){
  "use strict";
  var InputBase = require("./preview_base");
  module.exports = InputBase.extend({
    template: require("ldsh!../templates/input_text")
  });
});

